<template>
    <div class="locale-changer" id="language-selector">
        <select v-model="$i18n.locale">
            <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
                {{ lang }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'LanguageSelector',
    data () {
        return { langs: ['es', 'en'] }
    },
    created() {
        this.selectFirstAvailableLanguage()
    },
    methods: {
        selectFirstAvailableLanguage() {
            for (let language of navigator.languages) {
                language = language.split('-')[0]
                if (this.langs.includes(language)) {
                    this.$i18n.locale = language
                    break
                }
            }
        }
    },
}
</script>
